<template>
  <div class="print-pay-fee-container">
    <div class="receipt-sheet">
      <div class="print-field payer-name">{{ printPayFeeInfo.payObjName }}</div>
      <div class="print-field room-address">{{ printPayFeeInfo.roomName }}</div>
      <div class="print-field pay-date">{{ dateFormat(printPayFeeInfo.feeTime) }}</div>
      <div class="print-field pay-method">{{ payMethodText }}</div>

      <table class="receipt-detail">
        <thead>
          <tr>
            <th class="col-room">&#25143;&#21495;</th>
            <th class="col-period">&#26399;&#38388;</th>
            <th class="col-name">&#39033;&#30446;</th>
            <th class="col-money">&#26412;&#27425;&#37329;&#39069;</th>
            <th class="col-money">&#23567;&#35745;</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in printPayFeeInfo.fees" :key="index">
            <td class="col-room">{{ roomNoText(item.objName) }}</td>
            <td class="col-period">{{ feeRangeText(item) }}</td>
            <td class="col-name">{{ item.feeName }}</td>
            <td class="col-money">{{ moneyText(item.amount) }}</td>
            <td class="col-money">{{ moneyText(item.amount) }}</td>
          </tr>
        </tbody>
      </table>

      <div class="receipt-summary">
        <span>上次余额</span>
        <strong>{{ moneyText(receiptSummary.lastBalance) }}</strong>
        <span>本次应收</span>
        <strong>{{ moneyText(receiptSummary.receivableAmount) }}</strong>
        <span>本次实收</span>
        <strong>{{ moneyText(receiptSummary.receivedAmount) }}</strong>
        <span>本次余额</span>
        <strong>{{ moneyText(receiptSummary.currentBalance) }}</strong>
      </div>

      <div class="print-field capital-amount">{{ changeNumMoneyToChinese(receiptSummary.receivedAmount) }}</div>
      <div class="print-field lower-amount">&yen;{{ moneyText(receiptSummary.receivedAmount) }}</div>
      <div class="print-field receipt-unit">{{ printPayFeeInfo.communityName }}</div>
      <div class="print-field maker">{{ userInfo.name }}</div>
      <div class="print-field collector">{{ userInfo.name }}</div>
    </div>

    <el-row id="print-btn" class="print-actions">
      <el-col :span="24">
        <el-button type="primary" class="float-right" @click="handlePrint">
          <i class="el-icon-printer"></i>&nbsp;{{ $t('common.print') }}
        </el-button>
        <el-button type="warning" class="float-right" style="margin-right:20px;" @click="handleClose">
          {{ $t('common.cancel') }}
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getCommunityId, getCommunityName } from '@/api/community/communityApi'
import { queryFeeReceipt, queryFeeReceiptDetail, queryFeePrintSpec } from '@/api/fee/printPayFeeApi'
import { getUserId, getUserName } from '@/api/user/userApi'
import { dateFormat } from '@/utils/dateUtil'
import { changeNumMoneyToChinese } from '@/utils/moneyUtil'

export default {
  name: 'PrintPayFeeList',
  data() {
    return {
      printPayFeeInfo: {
        communityName: '',
        receiptId: '',
        receiptIds: '',
        detailIds: '',
        roomName: '',
        amount: 0.00,
        fees: [],
        feeTime: '',
        wechatName: '',
        content: '',
        qrImg: '',
        payObjName: '',
        feeReceipt: [],
        apply: 'N',
        receiptNum: '',
        acctAmount: 0
      },
      userInfo: {},
      printFlag: '0',
      communityId: '',
      oldTitle: '',
      oldUrl: ''
    }
  },
  computed: {
    payMethodText() {
      const fee = this.printPayFeeInfo.fees.find(item => item.primeRate)
      return fee ? fee.primeRate : ''
    },
    receiptSummary() {
      const fees = this.printPayFeeInfo.fees || []
      const receivableAmount = fees.reduce((total, item) => {
        return total + this.numberValue(item.receivableAmount)
      }, 0)
      const detailAmount = fees.reduce((total, item) => {
        return total + this.numberValue(item.amount)
      }, 0)
      const receiptAmount = this.firstNumberValue(
        this.printPayFeeInfo.amount,
        detailAmount
      )
      const firstFee = fees[0] || {}
      const balanceValues = [
        firstFee.lastBalance,
        firstFee.preBalance,
        firstFee.beforeBalance,
        this.printPayFeeInfo.lastBalance,
        this.printPayFeeInfo.preBalance,
        firstFee.currentBalance,
        firstFee.curBalance,
        firstFee.afterBalance,
        this.printPayFeeInfo.currentBalance,
        this.printPayFeeInfo.curBalance
      ]
      const lastBalance = this.firstNumberValue(
        firstFee.lastBalance,
        firstFee.preBalance,
        firstFee.beforeBalance,
        this.printPayFeeInfo.lastBalance,
        this.printPayFeeInfo.preBalance,
        0
      )
      const currentBalance = this.firstNumberValue(
        firstFee.currentBalance,
        firstFee.curBalance,
        firstFee.afterBalance,
        this.printPayFeeInfo.currentBalance,
        this.printPayFeeInfo.curBalance,
        lastBalance
      )
      const balanceReceivedAmount = this.toMoneyNumber(this.hasNumberValue(...balanceValues)
        ? receivableAmount - lastBalance + currentBalance
        : detailAmount)
      const receivedAmount = this.toMoneyNumber(this.hasNumberValue(this.printPayFeeInfo.amount)
        ? receiptAmount
        : balanceReceivedAmount)
      return {
        lastBalance,
        receivableAmount,
        receivedAmount,
        currentBalance
      }
    }
  },
  created() {
    this.oldTitle = document.title
    document.title = ''
    this.communityId = getCommunityId()
    this.userInfo = {
      userId: getUserId(),
      name: getUserName()
    }
    this.initData()
  },
  methods: {
    initData() {
      this.printPayFeeInfo.receiptId = this.$route.query.receiptId
      this.printPayFeeInfo.receiptIds = this.$route.query.receiptIds
      this.printPayFeeInfo.detailIds = this.$route.query.detailIds
      if (this.$route.query.apply) {
        this.printPayFeeInfo.apply = this.$route.query.apply
      }
      this.printPayFeeInfo.merge = this.$route.query.merge
      this.printPayFeeInfo.communityName = getCommunityName()

      this.loadReceipt()
      this.loadPrintSpec()
    },
    loadReceipt() {
      const params = {
        page: 1,
        row: 30,
        receiptId: this.printPayFeeInfo.receiptId,
        receiptIds: this.printPayFeeInfo.receiptIds,
        detailIds: this.printPayFeeInfo.detailIds,
        communityId: this.communityId
      }

      queryFeeReceipt(params).then(response => {
        const feeReceipt = response.data
        let amount = 0
        feeReceipt.forEach(item => {
          amount += parseFloat(item.amount)
        })

        this.printPayFeeInfo.amount = amount.toFixed(2)
        this.printPayFeeInfo.roomName = feeReceipt[0].objName
        this.printPayFeeInfo.feeTime = feeReceipt[0].createTime
        this.printPayFeeInfo.payObjName = feeReceipt[0].payObjName
        this.printPayFeeInfo.feeReceipt = feeReceipt
        this.printPayFeeInfo.receiptNum = feeReceipt[0].receiptCode

        this.loadReceiptDetail()
      })
    },
    loadReceiptDetail() {
      const params = {
        page: 1,
        row: 100,
        receiptId: this.printPayFeeInfo.receiptId,
        receiptIds: this.printPayFeeInfo.receiptIds,
        detailIds: this.printPayFeeInfo.detailIds,
        communityId: this.communityId,
        mergeFee: this.printPayFeeInfo.merge
      }

      queryFeeReceiptDetail(params).then(response => {
        const feeReceiptDetails = response.data
        this.printPayFeeInfo.receiptNum = this.printPayFeeInfo.receiptNum + '(' + feeReceiptDetails[0].payOrderId + ')'
        if (feeReceiptDetails[0].amount < 0) {
          this.printPayFeeInfo.apply = 'R'
        }
        let acctAmount = 0.0
        feeReceiptDetails.forEach(item => {
          acctAmount = acctAmount + parseFloat(item.acctAmount)
          this.printPayFeeInfo.feeReceipt.forEach(im => {
            if (item.receiptId == im.receiptId) {
              item.objName = im.objName
              item.feeTypeCd = im.feeTypeCd
            }
          })
        })
        this.printPayFeeInfo.fees = feeReceiptDetails
        this.printPayFeeInfo.acctAmount = acctAmount.toFixed(2)
      })
    },
    loadPrintSpec() {
      const params = {
        page: 1,
        row: 1,
        specCd: 2020,
        communityId: this.communityId
      }

      queryFeePrintSpec(params).then(response => {
        const data = response.data
        if (data.length > 0) {
          this.printPayFeeInfo.content = data[0].content
          this.printPayFeeInfo.qrImg = data[0].qrImg
          if (data[0].printName) {
            this.printPayFeeInfo.communityName = data[0].printName
          }
        }
      })
    },
    dateFormat(date) {
      if (!date) return ''
      return dateFormat(date)
    },
    feeRangeText(item) {
      if (!item) return ''
      if (item.feeTypeCd === '888800010006') {
        return ''
      }
      const startTime = this.dateFormat(item.startTime)
      const endTime = this.dateFormat(item.endTime)
      if (startTime && endTime) {
        return `${startTime}-${endTime}`
      }
      return startTime || endTime
    },
    usageText(item) {
      if (!item) return ''
      if (item.preDegrees && item.curDegrees) {
        const usage = parseFloat(item.curDegrees) - parseFloat(item.preDegrees)
        return Number.isNaN(usage) ? '' : usage.toFixed(2)
      }
      return item.area || ''
    },
    roomNoText(roomName) {
      if (!roomName) return ''
      const parts = String(roomName).split('-').filter(item => item !== '')
      return parts.length > 0 ? parts[parts.length - 1] : roomName
    },
    numberValue(amount) {
      const value = parseFloat(amount)
      return Number.isNaN(value) ? 0 : value
    },
    firstNumberValue(...values) {
      for (const value of values) {
        if (value === null || value === undefined || value === '') {
          continue
        }
        const number = parseFloat(value)
        if (!Number.isNaN(number)) {
          return number
        }
      }
      return 0
    },
    hasNumberValue(...values) {
      return values.some(value => {
        if (value === null || value === undefined || value === '') {
          return false
        }
        return !Number.isNaN(parseFloat(value))
      })
    },
    toMoneyNumber(amount) {
      return Number(this.numberValue(amount).toFixed(2))
    },
    moneyText(amount) {
      const value = parseFloat(amount)
      if (Number.isNaN(value)) {
        return '0.00'
      }
      return value.toFixed(2)
    },
    changeNumMoneyToChinese,
    handlePrint() {
      this.printFlag = '1'
      document.getElementById('print-btn').style.display = 'none'
      this.oldTitle = this.oldTitle || document.title
      this.oldUrl = window.location.href
      document.title = ''
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', window.location.origin + window.location.pathname + window.location.hash.split('?')[0])
      }
      this.$nextTick(() => {
        setTimeout(() => {
          window.print()
          document.title = this.oldTitle
          if (this.oldUrl && window.history && window.history.replaceState) {
            window.history.replaceState(null, '', this.oldUrl)
          }
          window.close()
        }, 300)
      })
    },
    handleClose() {
      window.close()
    }
  }
}
</script>

<style scoped>
.print-pay-fee-container {
  min-height: 100vh;
  padding: 12px;
  background: #f5f5f5;
}

.receipt-sheet {
  position: relative;
  width: 210mm;
  height: 127mm;
  margin: 0 auto;
  overflow: hidden;
  color: #000;
  background: #fff url('/img/receipt/dongxin-receipt-bg.jpg') center center / 100% 100% no-repeat;
  font-family: SimSun, 'Microsoft YaHei', serif;
  font-size: 15px;
}

.print-field {
  position: absolute;
  min-height: 5mm;
  line-height: 5mm;
  white-space: nowrap;
  color: #000;
}

.payer-name {
  top: 17.5mm;
  left: 39mm;
  width: 39mm;
  text-align: left;
}

.room-address {
  top: 24mm;
  left: 39mm;
  width: 65mm;
  text-align: left;
}

.pay-date {
  top: 17.5mm;
  left: 103mm;
  width: 33mm;
  text-align: left;
}

.pay-method {
  top: 24mm;
  left: 103mm;
  width: 33mm;
  text-align: left;
}

.receipt-detail {
  position: absolute;
  top: 32mm;
  left: 18mm;
  width: 165.6mm;
  border-collapse: collapse;
  table-layout: fixed;
  color: #000;
  font-size: 12px;
}

.receipt-detail th {
  height: 6mm;
  line-height: 6mm;
  padding: 0 1mm;
  overflow: hidden;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
  font-weight: 700;
  border: none;
}

.receipt-detail td {
  height: 6mm;
  line-height: 1.2;
  padding: 0 1mm;
  overflow: hidden;
  text-align: center;
  vertical-align: middle;
  word-break: break-all;
  border: none;
}

.receipt-summary {
  position: absolute;
  top: 99.9mm;
  left: 30mm;
  width: 134.2mm;
  height: 6mm;
  line-height: 6mm;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #000;
  font-size: 14px;
  white-space: nowrap;
}

.receipt-summary span {
  font-weight: 700;
}

.receipt-summary strong {
  min-width: 18mm;
  padding: 0 2mm;
  text-align: center;
  font-weight: 400;
}

.col-period {
  width: 43.5mm;
}

.col-name {
  width: 43.5mm;
}

.col-room {
  width: 17.4mm;
}

.receipt-detail th.col-room,
.receipt-detail td.col-room {
  padding-left: 1mm;
  text-align: left;
}

.col-meter {
  width: 15mm;
}

.col-area {
  width: 14mm;
}

.col-package {
  width: 12mm;
}

.col-price {
  width: 13mm;
}

.col-rate {
  width: 10mm;
}

.col-money {
  width: 26.1mm;
}

.capital-amount {
  top: 110mm;
  left: 20mm;
  width: 98.5mm;
  font-size: 16px;
}

.lower-amount {
  top: 110mm;
  left: 160mm;
  width: 24.4mm;
  font-size: 16px;
}

.receipt-unit {
  top: 118mm;
  left: 16.5mm;
  width: 50.5mm;
  font-size: 16px;
}

.maker {
  top: 118mm;
  left: 117.5mm;
  width: 36.6mm;
  font-size: 16px;
}

.collector {
  top: 118mm;
  left: 161.5mm;
  width: 30.5mm;
  font-size: 16px;
}

.float-right {
  float: right;
}

.print-actions {
  width: 210mm;
  margin: 16px auto 0;
}
</style>

<style>
@page {
  size: 210mm 126mm;
  margin: 0 !important;
}

@media print {
  html,
  body {
    margin: 0 !important;
    padding: 0 !important;
  }

  .print-pay-fee-container {
    min-height: auto !important;
    padding: 0 !important;
    background: #fff !important;
  }

  .receipt-sheet {
    margin: 0 !important;
    background: #fff !important;
  }

  #print-btn {
    display: none !important;
  }
}
</style>
